<template>
  <div>
    <FITFormCard>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <h4>購買商舖管理</h4>
            <h5>當前管理員: {{username}}</h5>
          </b-col>
          <b-col cols="6" class="text-right">
            <b-button v-if="permissionLevel<3.5" variant="primary" size="md" @click="initCreateModal"><i class="fa fa-plus mr-2"></i>新增購買商鋪</b-button>

            <b-button v-if="permissionLevel<3.5" variant="success" size="md" @click="createCSV"><i class="fa fa-download mr-2"></i>匯出購買商鋪列表</b-button>

          </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <FITSearchableTable :keywordPlaceholder="placeholder" ref="storeList" :filters="filters" :actions="actions" :columns="updatedColumns" vuexModule="Homepage" searchAction="getFinalStoreList" type="product" :defaultPagination="pagination">
      <!--     <template slot="leftEyeImage" slot-scope="data">
            <img :src="getImageUrl(data.data)" onerror="'http://www.markweb.in/primehouseware/images/noimage.png'" class="imagePreview pr-3" width="120" style="height: auto;">
          </template>
           <template slot="rightEyeImage" slot-scope="data">
            <img :src="getImageUrl(data.data)" onerror="'http://www.markweb.in/primehouseware/images/noimage.png'" class="imagePreview pr-3" width="120" style="height: auto;">
          </template> -->
        </FITSearchableTable>
      </div>
    </FITFormCard>
    <div>
      <!-- <b-button >Launch demo modal</b-button> -->

      <b-modal v-model="modalShow"  title="創建/更改商店資料"  @ok="modelSubmit">
        <div style="padding-left:15px; padding-right: 15px; ">
          <FITTextInput :width="9"  label="商舖ID" :disabled="true" v-model="storeForm.ID" v-if="storeForm.ID"></FITTextInput>     
          <FITSelect :rule="{required:true}" :width="9" label="商戶編號" v-model="storeForm.accountID" :options="merchantList"></FITSelect>
          <FITCheckbox v-model="showCreateMerchant"></FITCheckbox><span class="text-danger font-weight-bold">(如無商戶編號請先新增商戶編號)</span>
          <div v-if="showCreateMerchant">
            <FITTextInput :rule="{minLength:6, maxLength:10, required: true, numeric:true}" :width="9"  v-model="merchantForm.username" ></FITTextInput>
            <b-button  variant="success" size="md" @click="createMerchant">新增商戶</b-button>
          </div>
          <FITTextInput :rule="{required:true}" :width="9"  label="商舖名稱" v-model="storeForm.name"></FITTextInput>
          <span class="text-default">專屬登記網址：<br/><a :href="uniqueRegistrationURL(storeForm.accountID)" target="_blank">{{uniqueRegistrationURL(storeForm.accountID)}}</a></span>
          <FITSelect @input="resetDistrict()" :rule="{required:true}" :width="9" label="地區" v-model="selectedRegion" :options="this.selections.region"></FITSelect>
          <FITSelect  :rule="{required:true}" :disabled="!selectedRegion"  :width="9" label="地點" v-model="storeForm.parentKey" :options="this.updatedDistrictList"></FITSelect>

          <FITTextInput :rule="{required:true}" :width="9"  label="商舖地址" v-model="storeForm.address"></FITTextInput>
          <span class="text-default">座標查詢網址：<a href="https://www.latlong.net/" target="_blank">https://www.latlong.net/</a></span>
          <FITTextInput :rule="{required:true}" :width="9"  label="座標Lat" v-model="storeForm.latitude"></FITTextInput>
          <FITTextInput :rule="{required:true}" :width="9"  label="座標Long" v-model="storeForm.longitude"></FITTextInput>

          <FITTextInput :rule="{minLength:8, maxLength:8, numeric:true, required:true}" :width="9"  label="聯絡電話" v-model="storeForm.telephone"></FITTextInput>
          <FITTextInput :rule="{minLength:8, maxLength:8, numeric:true}" :width="9"  label="SMS電話號碼" v-model="storeForm.smsPhone"></FITTextInput>
          <FITSelect :width="9"  label="近視/遠視" v-model="storeForm.short" :options='productOption'></FITSelect>
          <FITSelect :width="9"  label="散光" v-model="storeForm.light" :options='productOption'></FITSelect>
          <FITSelect :width="9"  label="漸進" v-model="storeForm.axis" :options='productOption'></FITSelect>
          <FITSelect :width="9"  label="免費試戴" v-model="storeForm.freeTrial" :options='offerOption'></FITSelect>
          <FITSelect :width="9"  label="特選優惠" v-model="storeForm.trialOffer" :options='offerOption'></FITSelect>
        </div>
      </b-modal>
    </div>
  </div>

</template>
<script type="text/javascript">


  const selectionInitial = {
    gender: [],
    brand: [],
    product: [], // With parentKey
    lens: [],
    degree: [], // With parentKey
    region: [],
    district: [], // With parentKey
    store: [], // With parentKey
    productType:[],
  };

  const storeFormInitial = {
    "ID": '',
    // "type": "store",
    "accountID": '',
    "name": '',
    "region": '',
    "district": '',
    "parentKey": '',
    "address": '',
    "telephone": '',
    "smsPhone": '',
    "short": '',
    "light": '',
    "axis": '',
    "latitude":'',
    "longitude":'',
    "trialOffer":'N',
    "freeTrial":'N',
  };

  import { FITSearchableTable, FITFormCard, FITTextInput, FITSelect, FITCheckbox } from '@/components'
  import $ from 'jquery'
  import Cookies from 'js-cookie'

  export default {
    name: 'FinalStoreList',
    props: {},
    components: {
      FITSearchableTable,
      FITFormCard,
      FITTextInput,
      FITSelect,
      FITCheckbox
    },
    created(){
      this.selections = selectionInitial;
      this.storeForm = storeFormInitial;
      this.getAllSelections('selectionList');
      this.getMerchantList();
        // this.getAllSelections('storeList');
        // console.log(this.selections)
      },

      data(){
       return{
        placeholder:'Region / District / Telephone / Name',
        selections:{},
        filters:[],
        pagination:{
          page:1,
          count:100,
        },
        merchantList:[],
        modalShow:false,
        storeForm:{},
        selectedRegion:"",
        showCreateMerchant:false,
        merchantForm:{
          username:'',
        },
        productOption:[
        {value:"", text:'-'},
        {value:"Y", text:'Y'},
        ],
        offerOption:[
        {value:"N", text:'N'},
        {value:"Y", text:'Y'},
        ],
        actions:[
        {
          text: "修改",
          key: 'edit',
          class:'text-primary',
          callback: (key, row, instance) => {
            // Vue.set(this, 'clickedRow', row);
            // this.redeemRecord(row.ID,row.promoteStatus);
            this.storeForm = row;

            // Convert Region and District Text to Value, then put into selectedRegion and storeForm.parentKey

            this.selections.region.forEach((region)=>{
              if(region.text == row.region){
                this.selectedRegion = region.value;
              }
            })

            this.selections.district.forEach((district)=>{
              if(district.text == row.district){
                this.storeForm.parentKey = district.value;
              }
            })

            this.modalShow = true;

          }
        },
        {
          text: "登記頁面僅顯示資料",
          key: 'displayOnly',
          class:'text-primary',
          callback: (key, row, instance) => {
            let formData = JSON.parse(JSON.stringify(row));
            formData.freeTrial = "N";
            formData.trialOffer = "Y";
            this.selections.district.forEach((district)=>{
              if (district.text == formData.district) {
                formData.parentKey = district.value
              }
            })

            // console.log(formData.district)
            // console.log(this.updatedDistrictList)
            this.$store.dispatch('Homepage/updateFinalStore', formData).then((json)=>{        
              if(json.status != 200){
                alert(json.message)
              }else{
            // this.$store.dispatch('Homepage/getStoreList',this.pagination);
            this.$refs.storeList.search(this.pagination)
            this.storeForm = storeFormInitial;
          }
        })
          }
        },  
        {
          text: "商鋪上架",
          key: 'onShelf',
          class: 'text-primary',
          permission:3.5,
          callback: (key, row, instance) => {
            // Vue.set(this, 'clickedRow', row);
            // console.log(row);
            this.deleteRecord(row.ID, '1');
          }
        },
        {
          text: "商鋪下架",
          key: 'offShelf',
          class: 'text-danger',
          permission:3.5,
          callback: (key, row, instance) => {
            // Vue.set(this, 'clickedRow', row);
            // console.log(row);
            this.deleteRecord(row.ID, '0');
          }
        },

        ],
        columns:[
        {
          key: 'ID',
          label: '商舖ID',
        },
        {
          key: 'name',
          label: '名稱',
        },
        {
          key: 'region',
          label: '地區',
        },
        {
          key: 'district',
          label: '地點',
        },
        {
          key: 'address',
          label: '商舖地址',
        },
        {
          key: 'accountID',
          label: '商戶編號',
        },
        // {
        //   key: 'latitude',
        //   label: '座標Lat',
        // },
        // {
        //   key: 'longitude',
        //   label: '座標Long',
        // },
        {
          key: 'telephone',
          label: '聯絡電話',
        },
        // {
        //   key: 'smsPhone',
        //   label: 'sms聯絡電話',
        // },
        {
          key: 'short',
          label: '近視/遠視',
        },
        {
          key: 'light',
          label: '散光',
        },
        {
          key: 'axis',
          label: '漸進',
        },
                // {
        //   key: 'createTime',
        //   label: '創建時間',
        // },
        {
          key: 'freeTrial',
          label: '免費試用',
        },
        {
          key: 'trialOffer',
          label: '特選優惠',
        },
        {
          key: 'updateTime',
          label: '更新時間',
        },
        {
          key: 'version',
          label: '狀態',
          formatter: (row, key, item) => {
            let result = '';
            if(row == '0'){
              result = "已下架";
            }else if(row == '1'){
              result = "生效中";
            }
            return result;
          }
        },


        // {
        //   key: 'promoteStatus',
        //   label: '換領狀態',
        //   // tdClass:[],
        //   formatter: (row, key, item) => {
        //     let classStr = 'text-primary';
        //     if(row == "Y"){
        //       classStr = 'text-success'; 
        //     }
        //     let tag = `<span class="font-weight-bold ${classStr}">${this.getTranslated(key, row)}</span>`
        //     return tag;
        //   }
        // },

        // {
        //   key: 'updateTime',
        //   label: '換領日期',
        //   formatter: (row, key, item) => {
        //    return this.getTranslated(key, row);
        //   }
        // },

        ],
      }
    },
    watch:{
    // selectedRegion:function(newVal){
    //   this.storeForm.parentKey = "";
    // }
  },
  computed:{
    updatedDistrictList(){
      if(!this.selectedRegion) return [];
      let districtList = [];
      this.selections.district.forEach((district)=>{
        if(district.parentKey == this.selectedRegion){
          districtList.push(district);
        }
      })
      // console.log(districtList)
      return districtList;
    },
    permissionLevel() {
      return Cookies.get('permissionLevel');
    },
    username() {
      return Cookies.get('username');
    },
    updatedColumns(){
      let columns = this.columns;
      let ignoreColumns = [
      'informationFlag',
      'emailFlag',
      'smsFlag'
      ];
      let columnIndex= 0;
      if(this.permissionLevel >3.5){
        $.each(columns,(index,value)=>{
          if(value.key == 'informationFlag')
          {
           columnIndex = index ;
         }
       });
        columns.splice(columnIndex,3);    
      }
      return columns;
    }
  },
  methods:{
    uniqueRegistrationURL(accountID){
      let accountPrefix = accountID.substr(0,6)
      let accountCode = 958146 - parseInt(accountPrefix)
      var url = "https://www.ultraoneday.com.hk/registration.html?code=" + accountCode
      return url 
    },
    resetDistrict(){
      this.storeForm.parentKey = '';
    },
    initCreateModal(){
      this.modalShow = !this.modalShow;
      this.storeForm = storeFormInitial;
      this.selectedRegion = '';
      this.merchantForm.username = '';
      this.showCreateMerchant = false;
    },

    modelSubmit(bvModalEvt){
      bvModalEvt.preventDefault()
      let formData = this.storeForm;

      if(!confirm('確認提交新增/修改商鋪資料？')){
        return;
      }

      
      // Convert ParentKey to Region and district
      this.selections.region.forEach((region)=>{
        if(this.selectedRegion == region.value){
          formData.region = region.text;
        }
      });
      this.selections.district.forEach((item)=>{
        if(formData.parentKey == item.value){
          formData.district = item.text;
        }
      });

      if((!formData.region)||(!formData.district)||(!formData.name)||(!formData.address)||(!formData.telephone)||(!formData.latitude)||(!formData.longitude)){
        alert("請填妥商店資料再重新提交。");
        return;
      }

      if(formData.ID){
        // Edit Store
        this.$store.dispatch('Homepage/updateFinalStore', formData).then((json)=>{

          if(json.status != 200){
            alert(json.message)
          }else{
            // this.$store.dispatch('Homepage/getStoreList',this.pagination);
            this.$refs.storeList.search(this.pagination)
            this.storeForm = storeFormInitial;
            this.modalShow = false;          
          }
        })

      }else{
        // Create Store
        delete formData["ID"];
        // delete formData["parentKey"];
        this.$store.dispatch('Homepage/createFinalStore', formData).then((json)=>{
          if(json.status != 200){
            alert(json.message)
          }else{
            // this.$store.dispatch('Homepage/getStoreList',this.pagination);
            this.$refs.storeList.search(this.pagination)
            this.storeForm = storeFormInitial;
            this.modalShow = false;          
          }
        })
      }

    },
    createMerchant(){
      if(confirm(`確認新增商戶${this.merchantForm.username}?`)){
        this.$store.dispatch('Homepage/createMerchant', this.merchantForm).then((json)=>{
          this.getMerchantList();
          this.showCreateMerchant = false;
          this.merchantForm.username = '';  

        });
      }
    },
    getMerchantList(){
      let merchantList = [];
      this.$store.dispatch('Homepage/getMerchantList',{type:'store'}).then((json)=>{
        json.data.list
        .forEach((user) => {
          merchantList.push({value:user.username, text:user.username});
        })
      });
      this.merchantList = merchantList;
        // console.log(this.merchantList);

      },
      getImageUrl(row){
      let imageDomain = process.env.DOMAIN + "/"; // production
      // let imageDomain = "https://test.tarvel.co/biotrue/rest/";  // Development
      // console.log(row);
      return imageDomain + row;
    },
    createCSV(){
      this.$store.dispatch('Homepage/exportFinalStore',{key:'exportFinalStore', code: '2SF945XC!@SDF34'});
    },
    redeemRecord(ID,status){

      if(status == 'Y'){
        alert("該推廣優惠碼已兌換");
        return;
      }

      if(!confirm("確認兌換該用戶的推廣優惠碼？")){
        return ;
      }

      if(!ID){
        return;
      }
      this.$store.dispatch('Homepage/redeemBIRecord',{'ID':ID})
      .then((json) => {
        this.$refs.storeList.search(this.pagination);
      });


    },
    deleteRecord(ID,status){
      if(!confirm("確認修改此店舖記錄狀態？")){
        return ;
      }
      if(!ID){
        return;
      }
      this.$store.dispatch('Homepage/deleteFinalStore',{'ID':ID, version:status})
      .then((json) => {
        this.$refs.storeList.search({ page: 1, count: 100 });
      });

    },
    getSubDegree( parentKey,value ){

      let degree = "";
      $.each(this.selections.degree, (index,item)=>{
        if  ((item.parentKey == parentKey)&&(item.value == value)){
          degree = item.text;
        }   
      });

      return degree;
    },

    getTranslated(key,value){
      let result = "/";
      switch(key){
        case 'accountID':
        case 'store':
        $.each(this.selections.store, (index,item)=>{
          if(item.ID == value){
            if(key == 'accountID'){result = item.accountID;}
            else if(key == 'store'){result =   result = `${item.name} (${item.address})` ;}
          }   
        });
        break;


        case 'updateTime':
        case 'createTime':
        if(value !=null){
          //   let dateTime = value.split(' ');
          // return dateTime[0];
          return value;
        }else{
          return '';
        }

        break;
        case 'promoteStatus':
        if(value == "Y"){
          return "已換領";
        }else{
          return "未領取";
        }

        break;
        
        case 'leftAxis':
        case 'rightAxis':
        result = this.getSubDegree("X",value);
        break;
        case 'leftShort':
        case 'rightShort':
        result = this.getSubDegree("S",value);
        break;
        case 'leftLight':
        case 'rightLight':
        result = this.getSubDegree("L",value);
        break;
        case 'informationFlag':
        case 'smsFlag':
        case 'emailFlag':

        if(value == "true"){
          result = '是';
        }else if(value == "false"){
          result = '否';
        }else{
          result = 'N/A';
        }
        break;
        default:
        $.each(this.selections[key], (index,item)=>{
          if(item.value == value){
            result = item.text;
          }   
        });
        break;

      }


      return result;

    },

    setAllSelections(list) {
            // console.log(list);
            $.each(list, (index, item) => {
              if (this.selections[item.type]) {
                    // if (item.parentKey) {
                    //     if (!this.selections[item.type][item.parentKey]) {
                    //         this.selections[item.type][item.parentKey] = [];
                    //     }
                    //     this.selections[item.type][item.parentKey].push(item);
                    // } else { // without parentKey
                    //     this.selections[item.type].push(item);
                    // }
                    this.selections[item.type].push(item);

                  }
                });
            // console.log(this.selections);
          },

          getAllSelections(key) {

            this.$store.dispatch('Homepage/getBISelections',key)
            .then((json) => {
              this.setAllSelections( json.data.list);   
            });
            // $.ajax({
            //         url: `${config.apiDomain}/selection/${key}List`,
            //         type: 'GET',
            //         dataType: 'json',
            //         data: {},
            //     })
            //     .done((data) => {
            //         if (data.status != 200) {
            //             alert(`getAll${key} Error: ${data.status}`);
            //             return;
            //         }
            //         // console.log(data);
            //         this.setAllSelections(key, data.data.list);
            //     })
            //     .fail(function() {
            //         alert(`getAll${key} fail`);
            //     })
          },
        }
      }

    </script>



// WEBPACK FOOTER //
// src/Homepage/components/Registration/FinalStoreList.vue